var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.names),function(name,id){return _c('v-sheet',{key:id},[_c('span',{staticClass:"text-caption secondary--text mx-2"},[_vm._v(_vm._s(name))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }